import gql from 'graphql-tag'

export const GetItemsInCart = () => {
    return gql`query getItemsInCart{
        getItemsInCart{
            Items {
                productID
                productName
                productShortDescription
                price
                quantity
                images
                companyEmail
                vendorName
            },
            nextToken
        }
      }`
}

export const EditProductQuantity = gql`mutation editProductQuantity($productId: String!, $quantity: Int!){
        editProductQuantity(input: {
            productID: $productId,
            quantity: $quantity
        })
  }`


export const RemoveProductFromCart = gql`mutation removeProductFromCart($productId: String!){
        removeProductFromCart(input: {
            productID: $productId
        })
  }`


export const AddProductToCart = gql`mutation addProductToCart($productId: String!, $productName: String!, 
$productShortDescription: String!, $price: Int!, $quantity: Int!, $images: [AWSURL]!, $companyEmail: String!,
$vendorName: String!){
        addProductToCart(input: {
            productID: $productId,
            productName: $productName,
            productShortDescription: $productShortDescription,
            price: $price,
            quantity: $quantity,
            images: $images,
            companyEmail: $companyEmail,
            vendorName: $vendorName
        })
  }`

export const requestPurchase = () => {
    return gql`query requestPurchase($requestData: RequestPurchaseInput){
        requestPurchase (input:$requestData)
    }`
}


// WEBPACK FOOTER //
// ./src/queries/cart.js